import { Depths, IButtonStyles } from "@fluentui/react";

export const transition = {
    short: "100ms"
} as const;

export const boxShadowDepths = {
    rest: Depths.depth4,
    hover: Depths.depth8,
    controls: Depths.depth16,
    surface: Depths.depth64
} as const;

export const hiddenScreenReaderElementStyles: IButtonStyles = {
    root: {
        position: "absolute",
        left: "-10000px",
        top: "auto",
        width: "1px",
        height: "1px",
        overflow: "hidden",
        clip: "rect(1px, 1px, 1px, 1px)"
    }
};

export const gutterSize = 16;
